export default "__VITE_ASSET__c53b5c50__"